// @ts-ignore

/**
 *
 * @param {string} link A URL Reference to a Breadcrumb item
 * @param {string} name A Name for the breadcrumb link ite, used as link text
 */
export namespace Navigation {

	let isTouchDevice = () => {
		return window.matchMedia("(pointer: coarse)").matches
	}
	let isSmallScreen = () => {
        return window.matchMedia("(max-width: 767px)").matches
	}
    window.addEventListener("resize", () => {
        isSmallScreen();
    });

	let setupNav = () => {

		// Lock or Unlock Body Scroll based on if dropdown menu is open
		const targetNode = document.body;
		const secondaryTargetNode = document.querySelector('.js-search-container');

		if(targetNode) {
			const config = { attributes: true };
			const callback = function(mutationsList, observer) {
				for(const mutation of mutationsList) {
					if (mutation.type === 'attributes') {

						if( (mutation.target.classList.contains('state-nav-open') ||
							 secondaryTargetNode.classList.contains('state-visible') )) {

							// check for visible scroll bar
							if ( $(document).height() > $(window).height() ) {
								var scrollTop = ($('html').scrollTop()) ? $('html').scrollTop() : $('body').scrollTop();
								$('html').addClass('noscroll').css('top',-scrollTop);
							}

						} else {

							var scrollTop = parseInt($('html').css('top'));
							$('html').removeClass('noscroll');
							$('html,body').scrollTop(-scrollTop);
						}
					}
				}
			};

			const observer = new MutationObserver(callback);
			observer.observe(targetNode, config);
		}


		// Init sub-navigation
		function closeAllSubNav(e: Event) {

			let navWasOpen = false;
			let allSubNavs = document.querySelectorAll('.js-sub-nav');

			// check to see if this was a body click while nav was open
			// if not, return. Otherwise continue closing the nav
			if (e.type === 'click') {
				let closestSubnavs = document.querySelectorAll('.js-sub-nav')
				closestSubnavs.forEach(function(closestSubnav) {
					if (closestSubnav.classList.contains('state-visible')){
						navWasOpen = true;
					}
				});
				if (!(navWasOpen)){
					return;
				}
			}

			// remove all of our active/visible state classes that we applied
			allSubNavs.forEach(function(allSubNav) {
				if (allSubNav.classList.contains('state-visible')){
					let mainNavItem = allSubNav.closest('.js-main-nav-item');
					mainNavItem.querySelector('.js-sub-nav-trigger').classList.remove('state-sub-nav-open');
					allSubNav.classList.remove('state-visible');
					document.body.classList.remove('state-nav-open');
				}
			});
		}

		//toggle mobile nav
		let mobileTrigger = document.querySelector('.js-main-nav-toggle');
		mobileTrigger.addEventListener('click', () => {

			let siteNav = document.querySelector('.js-site-nav');
			let searchNav = document.querySelector(".js-search-container");
			let searchToggle = document.querySelector('.js-mobile-search-toggle');

			searchToggle.classList.remove('state-open');
			document.body.classList.remove('state-quick-search-open');
			document.body.classList.remove('state-nav-open');

			if(siteNav.classList.contains('state-visible')) {
				siteNav.classList.remove('state-visible');
			} else {
				document.body.classList.add('state-nav-open');
				siteNav.classList.add('state-visible');
				searchNav.classList.remove('state-visible');
			}
		});

		// toggle mobile search
		let mobileSearchIcon = document.querySelector('.js-mobile-search-toggle');
		mobileSearchIcon.addEventListener('click', () => {
			let siteSearchContainer = document.querySelector('.js-search-container');
			let searchInput:HTMLElement =  document.querySelector('.secondary-nav__search-input');
			let siteNav = document.querySelector('.js-site-nav');

			if(mobileSearchIcon.classList.contains('state-open')) {
				mobileSearchIcon.classList.remove('state-open');
				siteSearchContainer.classList.remove('state-visible');
				document.body.classList.remove('state-quick-search-open');
			} else {
				mobileSearchIcon.classList.add('state-open');
				siteSearchContainer.classList.add('state-visible');
				siteNav.classList.remove('state-visible');
				searchInput.focus();
				document.body.classList.add('state-quick-search-open');
			}
		});

        // SMALL MOBILE DEVICE
		if (isTouchDevice() && isSmallScreen()) {
			// Mobile nav expand/collapse operation
			let subnavTriggers = document.querySelectorAll('.js-sub-nav-icon-trigger');
			subnavTriggers.forEach(function(subnavTrigger) {
				subnavTrigger.addEventListener('click', e => {

					e.preventDefault();
					e.stopPropagation();

					// remove selected states from existing items
					let mainNav = document.querySelector('.js-main-nav');
					let selectedState = mainNav.querySelector('.state-sub-nav-open');
					let openNav = mainNav.querySelector('.state-visible');
                    let navItem = subnavTrigger.closest('.js-sub-nav-trigger');

					if (selectedState){
                        selectedState.classList.remove('state-sub-nav-open');
                        navItem.classList.remove('state-sub-nav-open');
						openNav.classList.remove('state-visible');
						document.body.classList.remove('state-nav-open');
					}

					// add new selected states back if we didn't just close a menu
					if ( selectedState !== navItem){
						let subnavItem = subnavTrigger.closest('.js-main-nav-item').querySelector('.js-sub-nav');
						navItem.classList.toggle('state-sub-nav-open');
                        subnavItem.classList.toggle('state-visible');
						document.body.classList.add('state-nav-open');
					}

                    subnavTrigger.scrollIntoView();
				});
			});

			// Mobile sidebar nav expand/collapse operation
			let sidebarTriggers = document.querySelectorAll('.js-sidebar-icon-trigger');
			sidebarTriggers.forEach(function(sidebarTrigger) {
				sidebarTrigger.addEventListener('click', e => {

					e.preventDefault();
					e.stopPropagation();

					let sidebarVisible = document.querySelector('.sidebar-visible');
                    let sidebarItem = sidebarTrigger.closest('.js-sidebar-item');

					// remove selected states from existing items
					if (sidebarVisible){
						sidebarVisible.classList.remove('sidebar-visible');
					}

					// add new selected states back if we didn't just close a menu
					if ( sidebarVisible !== sidebarItem){
						// sidebarTrigger.classList.toggle('sidebar-visible');
						sidebarItem.classList.toggle('sidebar-visible');
					}

                    sidebarTrigger.scrollIntoView();
				});
			});
        } else {
			// Delayed hover operation: the megamenu covers a lot of the screen and is easy to trigger accidentally
			// Wait 300ms and if the user is still hovering, open the nav
			// handle MAIN NAV mouseover event
			let subnavTriggers = document.querySelectorAll('.js-sub-nav-trigger');
			subnavTriggers.forEach(function(subnavTrigger) {

                if (isTouchDevice()){
                    subnavTrigger.addEventListener('click', e => {
                        e.preventDefault();
                        e.stopPropagation();
                    });
                }

				var delay = function (elem, callback) {
					var timeout = null;
					elem.onmouseover = function() {
						// Set timeout to be a timer which will invoke callback after .3s
						timeout = setTimeout(callback, 300);
					};
					elem.onmouseout = function() {
						clearTimeout(timeout); // Clear any timers set to timeout
					}
				};

				delay(subnavTrigger, function() {
					let subnavItem = subnavTrigger.closest('.js-main-nav-item').querySelector('.js-sub-nav');
					document.body.classList.add('state-nav-open');
					subnavTrigger.classList.add('state-sub-nav-open');
					subnavItem.classList.add('state-visible');
                });
			});

			// handle SIDEBAR mouseover events
			let sidebarTriggers = document.querySelectorAll('.js-sidebar-trigger');

			sidebarTriggers.forEach(function(sidebarTrigger) {

				let subNav = sidebarTrigger.closest('.js-sub-nav');
				let sidebarDefault = subNav.querySelector('.js-sidebar-default');
				let sidebarItem = sidebarTrigger.closest('.js-sidebar-item');

                if (isTouchDevice()){
                    sidebarTrigger.addEventListener('click', e => {
                        e.preventDefault();
                        e.stopPropagation();
                    });
                }

				sidebarTrigger.addEventListener('mouseenter', e => {
					sidebarDefault.classList.add('state-hidden');
					sidebarTrigger.classList.add('state-visible');
					sidebarItem.classList.add('sidebar-visible');
				});

				sidebarItem.addEventListener('mouseleave', e => {
					sidebarTrigger.classList.remove('state-visible');
					sidebarItem.classList.remove('sidebar-visible');
					setTimeout(() => {
						sidebarDefault.classList.remove('state-hidden');
					}, 800);
			   });
			});

			// handle click on body or mouseleave on nav
			// close all menus
			let bodyElement = document.body;
            let closeButtons = document.querySelectorAll('.js-close');

			bodyElement.addEventListener('click', e => {
				closeAllSubNav(e);
			});

            closeButtons.forEach(function(closeButton){
                closeButton.addEventListener('click', e => {
                    closeAllSubNav(e);
                })
            });

			$('.js-main-nav-item').on('mouseleave', closeAllSubNav);

			$('body').on('click', closeAllSubNav);
		}

		if(isTouchDevice() && !isSmallScreen()) {
			let sidebarTriggers = document.querySelectorAll('.js-sidebar-icon-trigger');
			sidebarTriggers.forEach(function(sidebarTrigger) {
				sidebarTrigger.addEventListener('click', e => {
					e.stopPropagation();
					window.location.href = sidebarTrigger.parentElement.getAttribute('href');
				});
			});
		}

	}

	export const init = () => {
		setupNav();
	}
}
